<template>
  <iframe
    :src="content.content"
    style="position: absolute; top: 0; left: 0; width: 100%; min-height: 600px;"
    class="top-0 bottom-0 position-absolute w-100 h-100 left-0 right-0 h-100 border-0"
    allowfullscreen
  />
</template>
<script>

import { mapGetters } from 'vuex';
import timeHandlerMIxin from './timeHandlerMIxin';

export default {
  mixins: [timeHandlerMIxin],
  computed:{
    ...mapGetters(['content']),
  }
}
</script>

